import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Text" }
const _hoisted_2 = { class: "Text__Inner section__inner" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "Text__Background color--4" }, null, -1)
const _hoisted_4 = { class: "Text__Subinner section__subinner" }
const _hoisted_5 = { class: "section-title color--1" }
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.slide.title), 1),
          _createElementVNode("div", {
            class: "section-text",
            innerHTML: _ctx.paragraph(_ctx.slide.text)
          }, null, 8, _hoisted_6)
        ])
      ])
    ])
  ]))
}